import React, { Component } from 'react'
import Grid from '@material-ui/core/Grid'
import { makeStyles } from '@material-ui/core/styles'

import { connect } from 'react-redux'
import { uploadS3ZoomProgress, loadCourseDetails } from '../../actions/'

import { getCourseDetails } from '../../services/saga'

import Button from '@material-ui/core/Button'

import DescriptionIcon from '@material-ui/icons/Description'
import BrowserStore from 'store'
import LinearProgress from '@material-ui/core/LinearProgress'

import Alert from '@material-ui/lab/Alert'

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 200
  },

  chip: {
    margin: theme.spacing(0.5)
  }
}))

class UploadS3 extends Component {
  constructor() {
    super()
    this.state = { loadingCourse: true, data: [], error: '' }
  }

  async componentDidMount() {
    try {
      let courseData = await getCourseDetails(this.props.data.courseId)

      this.setState({ loadingCourse: false, data: courseData.data })

      this.props.courseDetailUpdate(courseData.data)
    } catch (e) {
      console.log(e)

      this.setState({
        loadingCourse: false,
        data: [],
        error: 'Course ID not found.'
      })
      this.props.courseDetailUpdate([])
    }
  }

  render() {
    const { data, uploadRequest } = this.props

    return (
      <React.Fragment>
        {this.state.error !== '' ? (
          <Alert severity='error'>{this.state.error}</Alert>
        ) : null}

        {this.state.loadingCourse === true ? (
          <div>
            <p>Course details are loading.. please wait.</p>
            <LinearProgress /> <br />
          </div>
        ) : null}

        <Grid container spacing={3}>
          <div>
            <ul>
              <li>
                Review
                <ul>
                  <li>Course ID: {data.courseId}</li>
                  <li>Requested By: {data.requestedBy} </li>
                  <li>Course Code: {this.state.data.course_code} </li>
                  <li>Sis Course ID: {this.state.data.sis_course_id}</li>
                  <li>Student Count: {this.state.data.total_students} </li>
                  <li>
                    Include Groups: {data.withGroups === true ? 'Yes' : 'No'}{' '}
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </Grid>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state) => ({
  data: state.CourseStudentExport
})
const mapDispatchToProps = (dispatch) => ({
  courseDetailUpdate: (data) => {
    dispatch(loadCourseDetails(data))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(UploadS3)
